
import { computed, defineComponent, PropType, ref } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useRoute } from 'vue-router'
import OpenDialogField from '@/components/_shared/open-dialog-field.vue'
import AgreementEditPackagesDialog from '@/components/agreements/dialogs/edit-packages-dialog.vue'
import { usePackageModule } from '@/modules/packages'
import EditablePackageField from '@/components/_shared/editable-package-field.vue'
export default defineComponent({
    name: 'agreements-open-dialog-field-packages',
    components: {
        EditablePackageField
    },
    props: {
        agreementPackages: {
            type: Array as PropType<string[]>
        }
    },
    setup (props) {
        const $q = useQuasar()
        const route = useRoute()
        const { packagesById } = usePackageModule()

        const agreementPackagesModel = ref(props.agreementPackages)

        const onValueUpdated = (newValue: string[]) => {
            agreementPackagesModel.value = newValue
        }

        function onChangePackages () {
            $q.dialog({
                component: AgreementEditPackagesDialog,
                componentProps: {
                    agreementPackages: agreementPackagesModel.value,
                    id: route.params.agreementId,
                    updateCallback: onValueUpdated
                }
            })
        }

        return {
            packages: computed(() => packagesById.value.size === 0 ? [] : agreementPackagesModel.value?.map(
                packageId => packagesById.value.get(packageId)?.name
            )),
            onChangePackages
        }
    }
})
